<div class="bg-[#0e365a] p-4 md:p-6">


    <div class="flex flex-col md:flex-row gap-4 ">
  <!-- Imagen -->
  <div class="w-full md:w-1/3">
    <img [src]="marcaInfo?.imagen_marca" alt="Beneficio" class="w-full h-full object-cover rounded-lg" />
  </div>

  <!-- Contenido -->
  <div class="flex flex-col text-white text-sm md:text-base w-full md:w-2/3 gap-3" *ngIf="marcaInfo">
    <div>
      <h3 class="headline-05">{{ marcaInfo.nombre_marca }}</h3>
      <p class="paragraph-default opacity-70">{{ marcaInfo.promo_desc_marca }}</p>
    </div>

    <div>
      <h3 class="headline-05">Promoción</h3>
      <!--<p class="headline-03 text-[#9FC7E7]">{{ marcaInfo.promo_marca }}</p>-->
      <p class="paragraph-small opacity-70">Válido hasta el {{ marcaInfo.vigencia_marca }}</p>
    </div>

    <div>
      <h3 class="headline-05">Términos y condiciones</h3>
      <p class="paragraph-default">{{ marcaInfo.restricciones_marca }}</p>
    </div>
  </div>
</div>

<div>
        <div class="pb-2 flex items-center justify-between my-3">
            <div>
                <h2 class="text-white headline-06 items-center gap-1">
                    Sucursales
                </h2>
                <p class="paragraph-default text-white/70">Encuentra los mejores descuentos para ti.</p>
            </div>
            <a (click)="goToBranches()" class="text-sm text-white/80 hover:underline cursor-pointer">Ver todos</a>
        </div>
    </div>

  <div class="carousel-container">
    <!-- Flecha izquierda -->
    <button 
      class="nav-arrow nav-arrow-left" 
      (click)="scrollSucursalLeft()" 
      [disabled]="!canScrollSucursalLeft"
      [class.disabled]="!canScrollSucursalLeft">
      <mat-icon>chevron_left</mat-icon>
    </button>

    <!-- Contenedor de cards -->
    <div class=" pb-6 overflow-x-auto overflow-y-hidden scrollbar-hide" #sucursalContainer>
      <div class="flex gap-4 w-max">
        <app-branch-card
          *ngFor="let sucursal of sucursales"
          [nombre]="sucursal.nombre"
          [telefono]="sucursal.telefono"
          [calle]="sucursal.calle"
          [numeroInterior]="sucursal.num_int"
          [referencias]="sucursal.referencia"
          [cp]="sucursal.cp">
        </app-branch-card>
      </div>
    </div>

    <!-- Flecha derecha -->
    <button 
      class="nav-arrow nav-arrow-right" 
      (click)="scrollSucursalRight()" 
      [disabled]="!canScrollSucursalRight"
      [class.disabled]="!canScrollSucursalRight">
      <mat-icon>chevron_right</mat-icon>
    </button>
  </div>

</div>